import { MILL_1 } from "@/setup/mill-config/mill-config";
import { MESApiService, spParameter } from "@dexteel/mesf-core";
import { get } from "lodash-es";
import { CatalogOperator } from "../models/CatalogOperator";

export const getOperators = async (
	params: {
		operatorId?: number | null;
		defaultAreaId?: string | number | null;
	},
	signal?: AbortSignal,
) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [];

	if (params.operatorId)
		parameters.push({ name: "OperatorId", value: params.operatorId });

	const resp = await apiService.callV2(
		`${Number(params.defaultAreaId) === MILL_1.id ? "[M1].[GetOperators]" : "[M2].[GetOperators]"}`,
		parameters,
		signal,
	);

	if (resp.ok) {
		return get(resp, "data.tables[0].rows", []) as CatalogOperator[];
	} else {
		throw new Error(resp.message || "Error fetching operators");
	}
};
export const upsertOperator = async (params: {
	operator: CatalogOperator;
	defaultAreaId?: string | number | null;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "OperatorId", value: params.operator.OperatorId },
		{ name: "OperatorName", value: params.operator.OperatorName },
		{ name: "Enabled", value: params.operator.Enabled },
	];

	const resp = await apiService.callV2(
		`${Number(params.defaultAreaId) === MILL_1.id ? "[M1].[UpsertOperator]" : "[M2].[UpsertOperator]"}`,
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error upserting operators");
	}
};

export const deleteOperator = async (params: {
	operatorId: number | null;
	defaultAreaId?: string | number | null;
}) => {
	const apiService = new MESApiService();

	const parameters: spParameter[] = [
		{ name: "OperatorId", value: params.operatorId },
	];

	const resp = await apiService.callV2(
		`${Number(params.defaultAreaId) === MILL_1.id ? "[M1].[DeleteOperator]" : "[M2].[DeleteOperator]"}`,
		parameters,
	);

	if (!resp.ok) {
		throw new Error(resp.message || "Error deleting operators");
	}
};
